<div *ngIf="reportType == 'unpaidOutstandingbriefly'">
  <div class="container" id="print-section">

    <table class="report-table">
      <thead>
        <tr>
          <th colspan="2" class="br-bottom br-right br-top small-text">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
          <th colspan="2" class="br-bottom br-right br-top small-text">Advt. Outstanding Report</th>
          <th colspan="3" class="br-bottom br-right br-top small-text">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th colspan="3" class="br-bottom br-right small-text">Unpaid Briefly</th>
          <!-- <th colspan="" class="br-bottom br-right small-text"></th> -->
          <th colspan="4" class="br-bottom small-text">
            Date: From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th class="br-bottom br-right small-text">Advt Name</th>
          <th class="br-bottom br-right small-text">Contact No</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Advt Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">GST Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Net Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Rcv Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of onlyOutstandingB">
        <!-- Office Representative -->
        <tr>
          <td colspan="7" class="br-bottom br-top bold-text off_rep_name">
            Office Rep Name:
            <span class="ft-wt-200" style="font-weight: bold;font-size: 17px;">{{ data.off_rep_name }} / {{ data.office_rep_mob }}</span>
          </td>
        </tr>

        <ng-container *ngFor="let data1 of data.rep_data">
          <!-- Inner Representative -->
          <tr>
            <td colspan="7" class="bold-text" style="font-weight: bold; font-size: 15px;background-color: lightblue;">
              Rep Name: {{ data1.rep_name }} / {{ data1.rep_mob_no }}
            </td>
          </tr>

          <!-- Advertiser Rows -->
          <tr *ngFor="let data2 of data1.advt_data">
            <td class="br-right" style="font-size: 14px;font-weight: bold;">{{ data2.advt_name }}</td>
            <td class="br-right">{{ data2.advt_mobile }}</td>
            <td class="br-right" style="text-align: right;font-weight: bold;">{{ (data2.contract_bkng_advt_amt * 1).toFixed(2) }}</td>
            <td class="br-right" style="text-align: right;font-weight: bold;">{{ (data2.contract_bkng_gst_amt * 1).toFixed(2) }}</td>
            <td class="br-right" style="text-align: right;font-weight: bold;">{{ (data2.contract_net_total * 1).toFixed(2) }}</td>
            <td class="br-right" style="text-align: right;font-weight: bold;">{{ (data2.contract_bkng_rcv_amt * 1).toFixed(2) }}</td>
            <td  style="text-align: right;font-weight: bold;">{{ (data2.contract_bal_amt * 1).toFixed(2) }}</td>
          </tr>

          <!-- Rep Totals -->
          <tr>
            <td colspan="2" class="br-top br-right bold-text">Total: {{ data1.rep_name }}</td>
            <td class="br-top br-right" style="font-weight: bold;text-align: right;font-size: 14px;">{{ (data1.advt_amt_total * 1).toFixed(2) }}</td>
            <td class="br-top br-right" style="font-weight: bold;text-align: right;font-size: 14px;">{{ (data1.gst_amt_total * 1).toFixed(2) }}</td>
            <td class="br-top br-right" style="font-weight: bold;text-align: right;font-size: 14px;">{{ (data1.net_amt_total * 1).toFixed(2) }}</td>
            <td class="br-top br-right" style="font-weight: bold;text-align: right;font-size: 14px;">{{ (data1.rcv_amt_total * 1).toFixed(2) }}</td>
            <td class="br-top" style="font-weight: bold;text-align: right;font-size: 14px;">{{ (data1.unpaid_amt_total * 1).toFixed(2) }}</td>
          </tr>
        </ng-container>
      </tbody>

      <!-- Grand Total -->
      <tfoot>
        <tr>
          <td colspan="2" class="br-bottom br-top br-right bold-text">Total: Rs</td>
          <td class="br-bottom br-top br-right bold-text" style="font-size: 18px;text-align: right;">{{ (onlytotalAdvtAmount * 1).toFixed(2) }}</td>
          <td class="br-bottom br-top br-right bold-text" style="font-size: 18px;text-align: right;">{{ (onlygstUnpaidAmount * 1).toFixed(2) }}</td>
          <td class="br-bottom br-top br-right bold-text" style="font-size: 18px;text-align: right;">{{ (onlytotalNetAmount * 1).toFixed(2) }}</td>
          <td class="br-bottom br-top br-right bold-text" style="font-size: 18px;text-align: right;">{{ (onlyrcvUnpaidAmount * 1).toFixed(2) }}</td>
          <td class="br-bottom br-top bold-text" style="font-size: 18px;text-align: right;">{{ (onlytotalUnpaidAmount * 1).toFixed(2) }}</td>
        </tr>
      </tfoot>
    </table>

    <!-- Footer & Actions -->
    <div class="footer-line"></div>
  </div>
   <div class="actions noPrint" style="text-align: right; margin-top: 10px;">
      <button mat-raised-button color="primary" (click)="exportExcel('Contract_InDetails_Report')" style="margin-right: 8px;">
        Export
      </button>
      <button mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint style="margin-right: 8px;">
        Print
      </button>
      <button mat-button mat-dialog-close>
        Close
      </button>
    </div>
</div>
